export default __webpack_public_path__ + "static/media/icn_edit-b.768aba2b.svg";